import React, { FC } from 'react';
import { StyledCheckbox } from './styles';

interface CheckboxProps {
  label?: string;
  checked: boolean;
  id: string;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}
/**
 * A checkbox component that accepts a label, an ID, whether it is checked or not,
 * a function to handle changes, and optionally if the checkbox should be disabled.
 */
const Checkbox: FC<CheckboxProps> = ({
  label,
  id,
  checked,
  onChange,
  disabled,
}) => {
  return (
    <StyledCheckbox>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={!!disabled}
      />
      <label htmlFor={id}>{label}</label>
    </StyledCheckbox>
  );
};

export default Checkbox;
